<template lang="">
  <div class="flex flex-row w-screen">
    <div class="w-full">
      <div
        class="lg:flex lg:items-center lg:justify-between my-4 lg:mx-12 mx-12"
      >
        <div class="flex justify-center lg:justify-start mt-4 min-w-0">
          <div>
            <h2
              v-if="!urlId"
              class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate"
            >
              All Batches
            </h2>
            <h2
              v-else
              class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate"
            >
              {{ projectName }} Batches
            </h2>
          </div>
        </div>
        <div
          class="mt-4 gap-3 w-min flex flex-col justify-center md:flex-row lg:mt-0 lg:ml-4"
        >
          <button
            v-if="$store.state.permissions.addBatch"
            @click="displayBatchModal = true"
            class="py-2 px-4 mt-2 mx-2 bg-woo rounded-lg text-white font-semibold"
          >
            Add batch
          </button>
        </div>
      </div>

      <GoodTable
        ref="table"
        :key="counter"
        :name="'batch'"
        :rows="batches"
        :columns="columns"
        :method1="viewBatchImages"
        :method2="deleteBatch"
        @openBatch="openBatch"
      />

      <AddBatchModal
        v-if="displayBatchModal"
        @addBatch="addBatch"
        @close="displayBatchModal = false"
      />
      <AddBatchModal
        v-if="displayBatchModal && this.$route.query.projectId"
        :receivedProjectId="urlId"
        @addBatch="addBatch"
        @close="displayBatchModal = false"
      />
      <FileNameModal
        v-if="displayFileNameModal"
        @exportBatch="exportBatch"
        @close="displayFileNameModal = false"
      />
      <UploadFileModal
        v-if="displayFileUploadModal"
        @importBatch="importBatch"
        @close="displayFileUploadModal = false"
      />
    </div>
  </div>
</template>
<script>
import GoodTable from "../components/GoodTable.vue";
import Http, { OCR_ENDPOINTS } from "../request";
import AddBatchModal from "../components/AddBatchModal.vue";
import FileNameModal from "../components/FileNameModal.vue";
import UploadFileModal from "../components/UploadFileModal.vue";

import moment from "moment";
import router from "../router";
export default {
  created() {
    this.getBatches();
    if (this.$route.query.projectId) {
      this.urlId = this.$route.query.projectId;
    }
  },

  components: {
    AddBatchModal,
    GoodTable,
    FileNameModal,
    UploadFileModal,
  },

  data() {
    return {
      urlId: null,
      displayFileNameModal: false,
      displayFileUploadModal: false,
      tempBatchId: null,
      projectName: null,
      batches: [],
      newBatches: [],
      displayBatchModal: false,
      counter: 0,
      columns: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Project Name",
          field: "projectName",
        },
        {
          label: "Creation Date",
          field: "creationDate",
        },
        {
          label: "Users",
          field: "numberOfUsers",
        },
        {
          label: "Images",
          field: "numberOfImages",
          type: "number",
        },
        {
          label: "Done",
          field: "numberOfDoneImages",
          type: "number",
        },
        {
          label: "Active",
          field: "active",
        },
        {
          label: "Actions",
          field: "actions",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    // Function to get images and go to view
    viewBatchImages(id) {
      Http()
        .get(OCR_ENDPOINTS.batches + "/" + id + "/images", {
          params: {
            size: 2000,
            page: 0,
          },
          showLoader: false,
        })
        .then((response) => {
          if (response.data.length != 0) {
            this.$store.commit("saveBatchImages", response.data);
            router.push("main-page-images");
          }
        })
        .finally(() => {});
    },

    addBatch(name, id) {
      Http()
        .post(OCR_ENDPOINTS.projects + `/${id}/batches`, { batchName: name })
        .then((response) => {
          this.getBatches();
          this.editBatchDetails = response.data;
          this.$toast.success("Batch added succesfully");
          this.displayBatchModal = false;
        })
        .catch((error) => {
          this.$toast.error(error.response.data);
        })
        .finally(() => {});
    },

    modifyData() {
      for (var i = 0; i < this.batches.length; i++) {
        if (this.batches[i].project) {
          this.batches[i].projectName = this.batches[i].project.name;
          this.batches[i].projectId = this.batches[i].project.id;
        }
        if (this.batches[i].creationDate)
          this.batches[i].creationDate = moment(
            this.batches[i].creationDate
          ).format("YYYY-MM-DD hh:mm a");
      }
    },

    addFind() {
      this.finds.push({ value: "" });
    },

    getBatches() {
      Http()
        .get(OCR_ENDPOINTS.batches, {
          params: {
            page: 0,
            size: 1000,
          },
          showLoader: true,
        })
        .then((response) => {
          this.projectName = response.data[0].project.name;
          this.batches = response.data;
          this.modifyData();
          if (this.urlId) {
            this.batches = this.batches.filter((obj) => {
              return obj.projectId == this.urlId;
            });
          }
        })
        .finally(() => {});
    },
    deleteBatch(batchId) {
      Http()
        .patch(OCR_ENDPOINTS.batches + batchId + "/active")
        .then((response) => {
          this.newBatch = response.data;
          let status = response.data.active;
          if (status) {
            this.$toast.success("Batch activated succesfully");
          } else {
            this.$toast.success("Batch deactivated succesfully");
          }
          this.afterDelete(batchId);
        })
        .finally(() => {});
    },
    afterDelete(batchId) {
      const batchIndex = this.batches.findIndex((batch) => batch.id == batchId);
      this.batches[batchIndex] = this.newBatch;
      this.modifyData();
      this.counter++;
    },

    openBatch(batchId, type) {
      this.tempBatchId = batchId;

      if (type == "export") {
        this.displayFileNameModal = true;
      } else {
        this.displayFileUploadModal = true;
      }
    },

    importBatch(file, deleteOldAnnotation) {
      let count = 0;
      let formData = new FormData();
      for (var f of file) {
        formData.append("file", f);
        count++;
      }
      // if (file[0].type) formData.append("type", file[0].type);

      Http()
        .post(
          OCR_ENDPOINTS.batches +
            this.tempBatchId +
            "/images/coco?deleteOldAnnotation=" +
            deleteOldAnnotation,
          formData
        )
        .then((response) => {
          this.$toast.success("File imported successfully");
        })
        .catch((error) => {
          this.$toast.error(error.response.statusText);
        })
        .finally(() => {
          this.tempBatchId = null;
        });
    },

    exportBatch(fileName, exportDoneImageOnly) {
      Http()
        .get(
          OCR_ENDPOINTS.batches +
            this.tempBatchId +
            "/images/coco?exportDoneImageOnly=" +
            exportDoneImageOnly,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          var a = document.createElement("a");
          a.href = window.URL.createObjectURL(response.data);
          a.download = fileName + ".JSON";
          a.click();
          this.$toast.success("File downloaded successfully");
          this.displayFileNameModal = false;
        })
        .catch((error) => {
          this.$toast.error(error.response.statusText);
        })
        .finally(() => {
          this.tempBatchId = null;
        });
    },
    closeModal() {
      this.deleteProject = false;
    },
  },
};
</script>
<style lang=""></style>
